import { FallbackProps } from "react-error-boundary";
import { Box, Typography } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { t } from "i18next";

export function AppErrorFallback({ error, resetErrorBoundary }: FallbackProps) {
    return (
        <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" minHeight="100vh" textAlign="center" p={3} sx={{ backgroundColor: "var(--root-bg-color)" }}>
            <ErrorOutlineIcon sx={{ fontSize: 64, color: "error.main", mb: 2 }} />
            <Typography variant="h5" gutterBottom sx={{ color: "var(--main-text-color)" }}>
                {t("Something went wrong")}
            </Typography>
            <Typography variant="body1" sx={{ color: "var(--muted-text-color)", mb: 3, maxWidth: 480 }}>
                {t("An unexpected error occurred. Please try again or reload the page.")}
            </Typography>
            <Box display="flex" gap={2}>
                <button id="error-try-again-btn" className="btn btn-add-new" onClick={resetErrorBoundary}>
                    {t("Try again")}
                </button>
                <button id="error-reload-btn" className="btn btn-add-new" onClick={() => window.location.reload()}>
                    {t("Reload page")}
                </button>
            </Box>
        </Box>
    );
}

export function RouteErrorFallback({ error, resetErrorBoundary }: FallbackProps) {
    return (
        <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" minHeight="60vh" textAlign="center" p={3}>
            <ErrorOutlineIcon sx={{ fontSize: 48, color: "error.main", mb: 2 }} />
            <Typography variant="h6" gutterBottom sx={{ color: "var(--main-text-color)" }}>
                {t("This page encountered an error")}
            </Typography>
            <Typography variant="body2" sx={{ color: "var(--muted-text-color)", mb: 3, maxWidth: 480 }}>
                {t("Something went wrong while loading this page. You can try again or navigate to a different page.")}
            </Typography>
            <button id="error-page-try-again-btn" className="btn btn-add-new" onClick={resetErrorBoundary}>
                {t("Try again")}
            </button>
        </Box>
    );
}
